export const isAbsoluteUri = (url) => {
  return /https?:/.test(url);
};
